// client/src/components/leagues/OutcomeSelector.js
import React from 'react'
import PropTypes from 'prop-types'
import { MATCH_STATUS } from '../../utils/matchStatus'

/**
 * OutcomeSelector - Radio buttons for selecting match outcome
 * Shows different options for admin vs regular players
 */
export default function OutcomeSelector({ outcome, onChange, isAdmin }) {
  return (
    <div className="mt-4">
      <div className="form-check">
        <input
          id="outcome-normal"
          name="outcome"
          type="radio"
          className="form-check-input"
          value={MATCH_STATUS.NORMAL}
          checked={outcome === MATCH_STATUS.NORMAL}
          onChange={() => onChange(MATCH_STATUS.NORMAL)}
        />
        <label className="form-check-label" htmlFor="outcome-normal">
          Match completed normally
        </label>
      </div>
      {isAdmin ? (
        <>
          <div className="form-check">
            <input
              id="outcome-home-retired"
              name="outcome"
              type="radio"
              className="form-check-input"
              value={MATCH_STATUS.HOME_RETIRED}
              checked={outcome === MATCH_STATUS.HOME_RETIRED}
              onChange={() => onChange(MATCH_STATUS.HOME_RETIRED)}
            />
            <label className="form-check-label" htmlFor="outcome-home-retired">
              Home player retired/defaulted (away wins)
            </label>
          </div>
          <div className="form-check">
            <input
              id="outcome-away-retired"
              name="outcome"
              type="radio"
              className="form-check-input"
              value={MATCH_STATUS.AWAY_RETIRED}
              checked={outcome === MATCH_STATUS.AWAY_RETIRED}
              onChange={() => onChange(MATCH_STATUS.AWAY_RETIRED)}
            />
            <label className="form-check-label" htmlFor="outcome-away-retired">
              Away player retired/defaulted (home wins)
            </label>
          </div>
        </>
      ) : (
        <>
          <div className="form-check">
            <input
              id="outcome-opponent-retired"
              name="outcome"
              type="radio"
              className="form-check-input"
              value={MATCH_STATUS.OPPONENT_RETIRED}
              checked={outcome === MATCH_STATUS.OPPONENT_RETIRED}
              onChange={() => onChange(MATCH_STATUS.OPPONENT_RETIRED)}
            />
            <label
              className="form-check-label"
              htmlFor="outcome-opponent-retired"
            >
              Opponent retired/defaulted
            </label>
          </div>
          <div className="form-check">
            <input
              id="outcome-i-retired"
              name="outcome"
              type="radio"
              className="form-check-input"
              value={MATCH_STATUS.I_RETIRED}
              checked={outcome === MATCH_STATUS.I_RETIRED}
              onChange={() => onChange(MATCH_STATUS.I_RETIRED)}
            />
            <label className="form-check-label" htmlFor="outcome-i-retired">
              I retired/defaulted
            </label>
          </div>
        </>
      )}
    </div>
  )
}

OutcomeSelector.propTypes = {
  outcome: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
}
